import { select } from './modules/itsSelect.js';
select();
// -----------------------------------------------------------------------------
import { newProductsSlide } from "./modules/new-products-slide.js";
newProductsSlide();
// -----------------------------------------------------------------------------
import * as wNumb from "./assets/wNumb.js";
import noUiSlider from 'nouislider';
import ItcCollapse from "./assets/collapse";
// -----------------------------------------------------------------------------
document.addEventListener('DOMContentLoaded', function() {
	function createUiSlider(filterElement, filterKey, min, max) {
		console.log(filterElement)
		console.log(filterKey)
		console.log(min)
		console.log(max)
		if (!filterElement) return;

		if (isNaN(min) || isNaN(max)) return;

		const priceStart = document.getElementById(filterKey+'-start');
		const priceEnd = document.getElementById(filterKey+'-end');
		if (!priceStart || !priceEnd) return;

		const inputs = [priceStart, priceEnd];

		// -----------------------
		// 🔹 Загружаем фильтры из localStorage
		const savedFilters = loadFiltersFromLocal();
		let startValue = min;
		let endValue = max;

		if (savedFilters[filterKey] && savedFilters[filterKey].length === 2) {
			const savedMin = Number(savedFilters[filterKey][0].replace(/\s/g, ''));
			const savedMax = Number(savedFilters[filterKey][1].replace(/\s/g, ''));
			if (!isNaN(savedMin)) startValue = savedMin;
			if (!isNaN(savedMax)) endValue = savedMax;
		}

		// -----------------------
		// 🔹 Создаём ползунок
		noUiSlider.create(filterElement, {
			start: [startValue, endValue],
			behaviour: 'drag',
			connect: true,
			tooltips: [
				wNumb({decimals: 0, thousand: ' ', suffix: ' (R)'}),
				wNumb({decimals: 0, thousand: ' ', suffix: ' (R)'})
			],
			range: {min: min, max: max},
			format: wNumb({decimals: 0, thousand: ' ', to: value => parseInt(value), from: value => parseInt(value)})
		});

		inputs[0].value = startValue;
		inputs[1].value = endValue;
		const filterInput = filterElement.closest('.filter__input');
		const dataViewStart = filterInput?.querySelector('[data-view-start]');
		const dataViewEnd   = filterInput?.querySelector('[data-view-end]');
		dataViewStart.value = startValue;
		dataViewEnd.value = endValue;
		// -----------------------
		// 🔹 Обновление localStorage при движении слайдера
		filterElement.noUiSlider.on('update', function (values) {
			inputs[0].value = values[0];
			inputs[1].value = values[1];
			dataViewStart.value = values[0];
			dataViewEnd.value = values[1];
			let filters = loadFiltersFromLocal();
			filters[filterKey] = [values[0], values[1]];
			saveFiltersToLocal(filters);
		});

		// -----------------------
		// 🔹 Обновление слайдера при ручном вводе
		inputs.forEach((input, handle) => {
			input.addEventListener('change', () => {
				const val = Number(input.value.replace(/\s/g, ''));
				if (!isNaN(val)) filterElement.noUiSlider.setHandle(handle, val);
			});
		});

		function saveFiltersToLocal(filters) {
			localStorage.setItem('filters', JSON.stringify(filters));
		}

		function loadFiltersFromLocal() {
			const saved = localStorage.getItem('filters');
			return saved ? JSON.parse(saved) : {};
		}

	}

	createUiSlider(
		document.getElementById('filter-density'),
		'density',
		window.filter.density.min,
		window.filter.density.max
	)
	createUiSlider(
		document.getElementById('filter-weight'),
		'weight',
		window.filter.weight.min,
		window.filter.weight.max
	)
	createUiSlider(
		document.getElementById('filter-price'),
		'price',
		window.filter.price.min,
		window.filter.price.max
	)


	const _loadedMenu = (el) => {
		const collapse = new ItcCollapse(el.querySelector('._collapse'));
		if (el.classList.contains('_active')) {
			el.classList.add('_open');
			collapse.toggle();
		}
	};
	const active_menu = document.querySelector('.menu-catalog').querySelector('._active');
	if (active_menu) _loadedMenu(active_menu);


	const menuParents = document.querySelectorAll('.menu-catalog__parent-menu');
	const menuList = document.querySelector('.sidebar-catalog__menu');
	menuParents.forEach((menuParent) => {
		const trigger = menuParent.querySelector('._trigger-menu');

		trigger.addEventListener('click', () => {
			const opened_menu = menuList.querySelector('._open');
			_toggleParentMenu(menuParent);
			if (opened_menu && opened_menu !== menuParent) {
				_toggleParentMenu(opened_menu);
			}
		});
	});

	const _toggleParentMenu = (menuParent) => {
		const collapseEl = menuParent.querySelector('._collapse');

		if (!collapseEl) {
			console.warn('._collapse не найден:', menuParent);
			return;
		}

		if (!collapseEl.classList) {
			console.warn('collapseEl не DOM элемент:', collapseEl);
			return;
		}

		const collapse = new ItcCollapse(collapseEl);

		menuParent.classList.toggle('_open');
		collapse.toggle();
	};

	const subMenuParents = document.querySelectorAll('.submenu-parent__menu');
	subMenuParents.forEach(subMenuParent => {
		const trigger = subMenuParent.querySelector('.submenu-parent__link');
		trigger.addEventListener('click', () => {
			if (trigger.classList.contains('_trigger')) {
				_toggleubMenu(subMenuParent);
			}

		});
	});
	const _toggleubMenu = (el) => {
		if (el.classList.contains('_active')) {
			el.classList.remove('_active');
		} else {
			el.classList.add('_active');
		}
	};
});



